module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "ovf-hd"
  }, [(_vm.flowsShow.length > 0) ? _c('div', _vm._l((_vm.flowsShow), function(fitem, index) {
    return _c('div', {
      staticClass: "ovf-hd p-b-10 tabTitle",
      class: {
        'm-t-20': index != 0, 'm-t-30': index == 0
      }
    }, [_c('div', {
      staticClass: "fw-b"
    }, [_c('span', {
      staticClass: "line"
    }), _vm._v(_vm._s(fitem.name))]), _vm._v(" "), _vm._l((fitem.list), function(item, findex) {
      return _c('div', {
        staticClass: "fl m-t-10 bg-wh w-190 h-190 tx-c pointer addFlow-cate",
        class: {
          'm-r-10': (1 + findex) % 6 != 0
        },
        on: {
          "click": function($event) {
            _vm.creatFlow(item.id)
          }
        }
      }, [_c('div', {
        staticClass: "w-60 flow-icon",
        class: item.icon,
        staticStyle: {
          "height": "60px"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "flow-name fz-18 h-25 text-overflow",
        attrs: {
          "title": item.name
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "flow-desc m-t-12 c-gra text-overflow fz-14",
        staticStyle: {
          "height": "50px"
        },
        attrs: {
          "title": item.description
        }
      }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('el-button', {
        staticClass: "flow-btn w-110 m-t-20 fz-14",
        attrs: {
          "type": "primary"
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle c-wh"
      }), _vm._v("\n               发起流程\n            ")])])
    })], true)
  })) : _c('div', {
    staticClass: "fl m-t-20 noData tx-c p-t-50 p-b-80"
  }, [_c('span', {
    staticClass: "null"
  }, [_vm._v("无相关数据")])]), _vm._v(" ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d481d7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/addFlow.vue
// module id = 1953
// module chunks = 2